import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as routes from '../src/config/constants';

const DeviceTokenComponent: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const deviceId = params.get('device_id') ?? '';
        const accessToken = params.get('access_token') ?? '';
        const refreshToken = params.get('refresh_token') ?? '';

        const fetchTokenAndNavigate = async () => {
            try {
                const response = await fetch(`${routes.BASE_URL}/auth/apptoken`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({})
                });

                const data = await response.json();
                localStorage.setItem('app_token', data.access_token);
                window.location.href = `/${routes.CARS}`;
            } catch (error) {
                console.error('Error:', error);
            }
        };

        if (accessToken.trim() !== '') {
            console.log('Setting token and redirecting...');
            localStorage.setItem('token', accessToken);

            if (refreshToken.trim() !== '') {
                localStorage.setItem('refresh_token', refreshToken);
            }

            if (deviceId.trim() !== '') {
                fetchTokenAndNavigate().catch(error => console.error('Promise rejected:', error));
            } else {
                console.log('Device ID is null or empty');
            }
        } else {
            console.log('Access token is null or empty');
        }
    }, [location, navigate]);

    return (
        <div>
            Redirecting...
        </div>
    );
};

export default DeviceTokenComponent;
